export default {
    getAllUsers: env => {
        return {
            url: `/${env}/users`,
            method: 'GET'
        };
    },
    getUserDetails: (env, userId) => {
        return {
            url: `/${env}/users/:userId`,
            method: 'GET',
            route_params: {
                userId
            }
        };
    },
    updateUserDetails: (env, userId, userForm) => {
        return {
            url: `/${env}/users/:userId`,
            method: 'PATCH',
            route_params: {
                userId
            },
            patch_params: {
                email: userForm.email,
                lastname: userForm.lastname,
                firstname: userForm.firstname,
                emailGoogle: userForm.emailGoogle,
                emailFacebook: userForm.emailFacebook,
                city: userForm.city,
                address: userForm.address,
                postalCode: userForm.postalCode,
                telFixe: userForm.telFixe,
                telPort: userForm.telPort,
                weatherCity: userForm.weatherCity
            }
        };
    },
    addUser: (env, userForm) => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field]) params[field] = userForm[field];
        });
        return {
            url: `/${env}/addUser`,
            method: 'POST',
            patch_params: params
        };
    },
    resetPassword: (env, userId, userForm) => {
        return {
            url: `/${env}/users/:userId/resetPassword`,
            method: 'PATCH',
            patch_params: {
                email: userForm.email,
                lastname: userForm.lastname,
                firstname: userForm.firstname
            },
            route_params: {
                userId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Users/api.js